import React, { useContext, useState } from "react";
import Card from "canvas-core-react/lib/Card";

import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import Margin from "canvas-core-react/lib/Margin";
import "./style.scss";
import { ButtonCancel } from "../buttonCancel";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";

export interface DownloadPDFProps {
  id?: string;
  text?: string;
}

export const DownloadPDF = ({
  id, text
}: DownloadPDFProps) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const resetModal = () => {
    setModalIsOpen(false);

  };
  const printPage = () => {
    window.print();

  }
  return (
    <>
      <Card>
        <Margin xs={12} sm={12} md={12} lg={12}>
          <>
            <Row>
              <Column xs={4} sm={8} md={12} lg={12}>
                <Margin xs={6} sm={6} md={6} lg={6}>
                  <Row>
                    <Column xs={4} sm={8} md={12} lg={12}>
                      <div id={id}
                      >{text}</div>
                      <TextSubtitle component="span">{"Imprimir presupuesto mensual"}</TextSubtitle>
                    </Column>
                  </Row>
                </Margin>
              </Column>

              <Column xs={4} sm={8} md={12} lg={12}>

                <ButtonCancel
                  title="Imprimir"
                  onClick={printPage}
                />
              </Column>
            </Row>
          </>
        </Margin>
      </Card>

    </>

  );
};
